import { SpotIcon, StyledCard, TotalPatient } from "@components";
import { IClientInfo } from "@interfaces";
import { theme } from "@utils";
import { Card, Divider, Progress, Tag } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface IProps {
  client: {
    data: IClientInfo[];
    loading: boolean;
  };
}

export const ClientInfo = ({ client: { data = [], loading } }: IProps) => {
  const { t } = useTranslation();
  const colors = [theme.colors.orange, theme.colors.green, theme.colors.yellow, theme.colors.gray];
  return (
    <StyledCard loading={loading} minwidth={640}>
      <header>
        <h5>{t("page.client_information")}</h5>
      </header>
      <Divider />
      <section className="client-info">
        {data.map((item, index) => (
          <Progress
            key={index}
            type="circle"
            percent={parseFloat(item?.percentage)}
            size={130}
            strokeColor={colors[index]}
            format={() => (
              <>
                {" "}
                <span className="progress-inner-text">{item?.title}</span>
                <br />
                {/* <span className="number small">{`${item?.generatedCount} of ${item?.redemmedCound}`}</span> */}
              </>
            )}
          />
        ))}
      </section>
      <footer className="client-footer">
        <div>
          {colors.map((color) => (
            <SpotIcon color={color} key={color} />
          ))}
          <p>{t("page.redeem")}</p>
        </div>
        <div>
          <SpotIcon color={theme.colors.white} />
          <p>{t("page.generate")}</p>
        </div>
      </footer>
    </StyledCard>
  );
};
